import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    logo: {
        margin: theme.spacing(1),
        width: 300,
        height: "auto"
    }
}));

export {useStyles};